export const FIXED_TIMESTEP = 1000 / 120;
export const ARENA_WIDTH = 800;
export const ARENA_HEIGHT = 1600;
export const PLANT_GREEN = "#5aff07";
export const DEAD_PLANT_BROWN = "#91490f";
export const FLIPPER_LENGTH = 120;
export const FLIPPER_RADIUS_START = 20;
export const FLIPPER_RADIUS_END = 10;
export const FLIPPER_ANGULAR_SPEED = 0.1;
